import { Injectable } from '@angular/core';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ConsoleLogger } from './console-logger';
import { ILogger } from './ilogger';

@Injectable({
  providedIn: 'root',
})
export class LoggerService extends ConsoleLogger {
  private initPromise: Promise<void>;
  private resolver!: () => void | PromiseLike<void>;
  public initialLoggers!: string[];
  public areAllEnabled = false;

  private loggers: { [name: string]: ILogger } = {};

  constructor(private config: ConfigurationModels.Configuration) {
    super('');

    this.initPromise = new Promise<void>((resolver, _reject) => {
      this.resolver = resolver;
    });
  }

  initialize(isAllEnabled: boolean) {
    this.areAllEnabled = isAllEnabled;

    this.initialLoggers = this.config.logging.loggers || [];

    this.initPromise.then(() => {
      if (isAllEnabled || this.config.logging.defaultLogger) {
        this.enable();
      } else {
        this.disable();
      }
    });

    this.resolver();
  }

  getLogger(name: string) {
    if (!this.loggers[name]) {
      this.addLogger(name);
    }

    return this.loggers[name];
  }

  enableLogger(name: string) {
    if (this.loggers[name]) {
      this.loggers[name].enable();
    }
  }

  disableLogger(name: string) {
    if (this.loggers[name]) {
      this.loggers[name].disable();
    }
  }

  /**
   * Add the logger and enables it if present in config
   * @param name logger name
   */
  private addLogger(name: string) {
    let logger = new ConsoleLogger(name);
    this.loggers[name] = logger;

    this.initPromise.then(() => {
      if (this.areAllEnabled || this.initialLoggers.indexOf(name) !== -1) {
        logger.enable();
      } else {
        logger.disable();
      }
    });
  }
}
